import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';
import { formatDate } from '@/utils/formatDate';

import {
  InputDateFilter,
  StatusIndicator,
  TableDropdownFilter,
} from '@/components';
import { TableData } from '@/components/Table/types';
import { ContainerRelease } from '../../types';

export type ParsedContainerRelease = Omit<
  ContainerRelease,
  'tipoContenedor' & 'cierreStacking'
> & {
  tipo?: string;
  tamano?: string;
};

export const getTableColumns = (
  data: ParsedContainerRelease[] | undefined
): ColumnProps[] => {
  return [
    {
      field: 'selection',
      header: '',
      filter: false,
      showFilterMenu: true,
      sortable: false,
      selectionMode: 'multiple',
      headerStyle: { width: '3rem' },
    },
    {
      field: 'armador',
      header: 'Armador',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="armador"
        />
      ),
    },
    {
      field: 'contenedor',
      header: 'Contenedor',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => <b>{rowData.contenedor}</b>,
    },
    {
      field: 'bls',
      header: 'Bl',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'consignatarios',
      header: 'Consignatarios',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'playaActual',
      header: 'P.Act',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tipo',
      header: 'Ti',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tipo"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tamano',
      header: 'Ta',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tamano"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'viaje',
      header: 'Viaje',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'llegada',
      header: 'Llegada',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} />
      ),
      filterField: 'llegada',
      dataType: 'date',
      headerStyle: { minWidth: '12rem' },

      body: (rowData) => (rowData.llegada ? formatDate(rowData.llegada) : '-'),
    },
    {
      field: 'playaDevolucion',
      header: 'P.Dev',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'fechaLiberadoHasta',
      header: 'Liberado',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} />
      ),
      headerStyle: { minWidth: '12rem' },
      filterField: 'fechaLiberadoHasta',
      dataType: 'date',
      body: (rowData) =>
        rowData.fechaLiberadoHasta
          ? formatDate(rowData.fechaLiberadoHasta)
          : '-',
    },
    {
      field: 'fechaRecibirHasta',
      header: 'Recibir',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} />
      ),
      headerStyle: { minWidth: '12rem' },
      filterField: 'fechaRecibirHasta',
      dataType: 'date',
      body: (rowData) =>
        rowData.fechaRecibirHasta ? formatDate(rowData.fechaRecibirHasta) : '-',
    },
    {
      field: 'estadoLiberacion',
      header: 'Estado',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="estadoLiberacion"
        />
      ),
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => <StatusIndicator status={rowData.estadoLiberacion} />,
    },
    {
      field: 'observacionesLiberacion',
      header: 'Observaciones',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
  ];
};
